import { useState } from 'react'
import { ConnectStoresRow } from './types'

export const defaultRow = (storeId: string): ConnectStoresRow => ({
  storeId,
  leatStoreId: null,
  leatOrderPushEnabled: true
})

// Row init is the caller's (the two screens differ); update logic is shared.
// `fallbackRow` is what a store with no row yet starts from.
export const useStoreLinkRows = (
  initRows: () => Record<string, ConnectStoresRow>,
  fallbackRow: (storeId: string) => ConnectStoresRow = defaultRow
) => {
  const [rows, setRows] = useState<Record<string, ConnectStoresRow>>(initRows)

  // Rows are seeded once while both screens re-derive their stores from live
  // props, so a store can be edited before it has a row.
  const updateRow = (storeId: string, patch: Partial<ConnectStoresRow>) => {
    setRows((current) => ({
      ...current,
      [storeId]: { ...fallbackRow(storeId), ...current[storeId], ...patch }
    }))
  }

  const getRow = (storeId: string): ConnectStoresRow =>
    rows[storeId] ?? fallbackRow(storeId)

  return { rows, updateRow, getRow }
}
